import React from 'react';
import './MenuCardAdmin.css';
import placeholderImage from '../../../assets/admin/images/placeholder.svg';

const S3_BUCKET_NAME = "resto-online";
const S3_BUCKET_REGION = "eu-north-1";
const S3_BASE_URL = `https://${S3_BUCKET_NAME}.s3.${S3_BUCKET_REGION}.amazonaws.com/`;

const MenuCardAdmin = ({ menu, onEditClick, onDeleteClick }) => {
  // Format price to Belgian Euro format
  const formatPrice = (price) => {
    const numPrice = typeof price === 'object' && price.$numberDecimal 
      ? parseFloat(price.$numberDecimal) 
      : parseFloat(price);
    
    return new Intl.NumberFormat('nl-BE', {
      style: 'currency',
      currency: 'EUR'
    }).format(numPrice);
  };

  // Calculate total price of all products in the menu
  const calculateTotalPrice = () => {
    if (!menu.products || menu.products.length === 0) {
      return formatPrice(0);
    }
    
    const total = menu.products.reduce((sum, product) => {
      const productPrice = typeof product.price === 'object' && product.price.$numberDecimal
        ? parseFloat(product.price.$numberDecimal)
        : parseFloat(product.price || 0);
      return sum + productPrice;
    }, 0);
    
    return formatPrice(total);
  };

  return (
    <div className="menu-card">
      <div className="menu-image-container">
        <img 
          src={menu.hasImage ? `${S3_BASE_URL}${menu._id}?t=${Date.now()}` : placeholderImage}
          alt={menu.name} 
          className="menu-image"
        />
        <div className="menu-tag">Menu</div>
      </div>
      
      <div className="menu-content">
        <h3 className="menu-title">{menu.name}</h3>
        <p className="menu-description">{menu.description || "Geen beschrijving"}</p>
        
        <div className="menu-details">
          <div className="menu-price">{formatPrice(menu.price || 0)}</div>
          
          <div className="menu-products">
            <span className="products-label">Producten:</span>
            <span className="products-quantity">{menu.products?.length || 0}</span>
          </div>
          
          {menu.collection && (
            <div className="menu-collection">
              <span className="collection-icon"><img src={menu.collection.icon} alt={menu.collection.name} /></span>
              <span className="collection-name">{menu.collection.name}</span>
            </div>
          )}
          
          {menu.products && menu.products.length > 0 && (
            <div className="menu-total">
              <span className="total-label">Totale waarde:</span>
              <span className="total-price">{calculateTotalPrice()}</span>
            </div>
          )}
        </div>
      </div>
      
      <div className="menu-actions">
        <button onClick={() => onEditClick(menu)} className="edit-button">
          <i className="fi fi-rs-pencil"></i>
          <span>Bewerken</span>
        </button>
        
        <button onClick={() => onDeleteClick(menu)} className="delete-button">
          <i className="fi fi-rs-trash-xmark"></i>
          <span>Verwijderen</span>
        </button>
      </div>
    </div>
  );
};

export default MenuCardAdmin; 